/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Manager_Failed_Load_GroupsInputs */

const en_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to load groups: ${i?.error}`)
};

const fr_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du chargement des groupes : ${i?.error}`)
};

const de_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gruppen konnten nicht geladen werden: ${i?.error}`)
};

const it_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile caricare i gruppi: ${i?.error}`)
};

const ru_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить группы: ${i?.error}`)
};

const es_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al cargar los grupos: ${i?.error}`)
};

const zh_cn2_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`加载组失败：${i?.error}`)
};

const ja_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`グループの読み込みに失敗しました: ${i?.error}`)
};

const hi_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समूह लोड करने में विफल: ${i?.error}`)
};

const pt_pt2_knp_manager_failed_load_groups = /** @type {(inputs: Knp_Manager_Failed_Load_GroupsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao carregar os grupos: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to load groups: {error}" |
*
* @param {Knp_Manager_Failed_Load_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_failed_load_groups = /** @type {((inputs: Knp_Manager_Failed_Load_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Failed_Load_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_failed_load_groups(inputs)
	if (locale === "de") return de_knp_manager_failed_load_groups(inputs)
	if (locale === "it") return it_knp_manager_failed_load_groups(inputs)
	if (locale === "ru") return ru_knp_manager_failed_load_groups(inputs)
	if (locale === "es") return es_knp_manager_failed_load_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_failed_load_groups(inputs)
	if (locale === "ja") return ja_knp_manager_failed_load_groups(inputs)
	if (locale === "hi") return hi_knp_manager_failed_load_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_failed_load_groups(inputs)
	return en_knp_manager_failed_load_groups(inputs)
});